// OrderTraffic 组件配置文件
import { UNIFIED_TOOLTIP_STYLE } from '../../../configs/tooltipCommon';
export var ORDER_TRAFFIC_CHART_SETTINGS = {
    grid: {
        left: 60,
        right: 60,
        top: 24,
        bottom: 0,
    },
    tooltip: UNIFIED_TOOLTIP_STYLE,
};
